import { useQuery } from 'react-query';
import { GET_SELF_ONBOARDING_CONTRACTOR_DATA, formInitialData } from '../constants';
import { AppError } from 'utils/AppError';
import api from 'api';
import { parseGraphqlErrorFromExtensions } from 'utils/Api';
import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import { useToast } from '@razorpay/blade/components';
import { FormFields } from '../types';

export const useSavedContractorData = () => {
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const toast = useToast();

  const selfOnboardingQueryResponse = useQuery({
    queryKey: [GET_SELF_ONBOARDING_CONTRACTOR_DATA, loggedInUserId],
    queryFn: () => api.employeeOnboardingGql.queries.getSelfOnboardingData({ id: loggedInUserId! }),
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseGraphqlErrorFromExtensions(error),
        color: 'negative',
      });
      window.location.href = '/dashboard';
    },
    select: (data) => {
      const basicDetails = data?.getSelfOnboardingData?.data?.basicDetails;
      const personalDetails = data?.getSelfOnboardingData?.data?.personalDetails;
      const userStatutoryDetails = data?.getSelfOnboardingData?.data?.userStatutoryDetails;

      return {
        basicDetails,
        personalDetails,
        userStatutoryDetails,
      };
    },
    refetchOnMount: false,
  });

  const complianceSettings = {
    pan: selfOnboardingQueryResponse.data?.userStatutoryDetails?.panNumber ?? '',
    aadharNumber: '',
  };

  const employeeDetails = {
    personalDetails: selfOnboardingQueryResponse.data?.personalDetails,
    basicDetails: selfOnboardingQueryResponse.data?.basicDetails,
    complianceDetails: complianceSettings,
  };

  const personalDetailsResponse = selfOnboardingQueryResponse.data?.personalDetails || {};

  const dobValue = personalDetailsResponse?.dob;

  const maritalStatusValue = personalDetailsResponse?.maritalStatus;
  const genderValue = personalDetailsResponse?.gender;

  const marriageAnniversaryValue = personalDetailsResponse?.marriageAnniversary;

  const selfOnboardingFormInitialData: FormFields = {
    ...formInitialData,

    ...complianceSettings,
    ...personalDetailsResponse,
    
    dob: dobValue ? new Date(dobValue as string) : null,
    maritalStatus: maritalStatusValue ? [maritalStatusValue as string] : [],
    gender: genderValue ? [genderValue as string] : [],
    marriageAnniversary: marriageAnniversaryValue
      ? new Date(marriageAnniversaryValue as string)
      : null,
  };

  return {
    employeeDetails,
    selfOnboardingFormInitialData,
    isLoadingQuery: selfOnboardingQueryResponse.isLoading || selfOnboardingQueryResponse.isFetching,
  };
};
